import { render, staticRenderFns } from "./TickIcon.vue?vue&type=template&id=6427848a&scoped=true&"
import script from "./TickIcon.vue?vue&type=script&lang=js&"
export * from "./TickIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427848a",
  null
  
)

export default component.exports